module.exports = __webpack_public_path__ + "static/media/property-manager-bg.699acc7e.png";